export default "__VITE_ASSET__CSoopNEB__"